import { EChannel } from '@hosty-app/types';

export const AVAILABLE_CHANNELS: EChannel[] = ['hosty', 'airbnb', 'vrbo'];
